type TaskHandler = (event: unknown) => void;

export type TaskManagerTaskBody = {
  data?: unknown;
  error?: { message: string };
};

export function defineTask(_name: string, _handler: TaskHandler): void {}
